import React from 'react';
import { Link } from 'react-router-dom';
import { OFFER } from '../constants/demos';

const DoneForYouCallout = () => (
  <section className="mb-8 rounded-xl border border-blue-500/40 bg-blue-500/10 p-5 text-left">
    <h2 className="text-xl font-bold text-white mb-2">Want us to build your website?</h2>
    <p className="text-gray-300 text-sm mb-2">
      Our done-for-you website is ${OFFER.price} one-time, built and live in 48 hours. No monthly fees.
    </p>
    <p className="text-gray-300 text-sm mb-4">
      Get a free sample first and pay after approval. No account or PRO upgrade needed.
    </p>
    <Link
      to="/order"
      className="inline-flex min-h-11 max-w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-3 text-center font-semibold text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
    >
      Get my ${OFFER.price} website
    </Link>
  </section>
);

export default DoneForYouCallout;
